<template>
<!--  <div v-if="resError" id="error">
    <Alert banner closable :type="resError.status === 200 ? 'warning' : 'error'" @on-close="$store.commit('RES_ERROR')">
      <h3 class="title"> Status Code:
        <span :style="{color: resError.status === 200 ? '#093' : '#f33'}">
          <Icon :type="resError.status === 200 ? 'md-checkmark-circle' : 'md-close-circle'" size="24" style="margin-top: -2px;" /> {{ resError.statusCode }}
        </span>
      </h3>
      <div slot="desc" class="desc">
        <pre>{{ resError.error }}</pre>
      </div>
    </Alert>
  </div>-->
</template>
<script>
import { mapGetters } from "vuex";
import {Message} from "view-design";
export default {
  name: "IError",
  computed: {
    ...mapGetters({
      resError: "getResError"
    })
  },
  // 初始化
  watch: {
    resError(){
      console.log("this.resError.status:"+this.resError.status)
      console.log("this.resError.url:"+this.resError.url)

      if(this.resError && this.resError.url&& this.resError.url.indexOf("/login") == -1){
        if(this.resError.status === 401){
          this.$Modal.error({
            title: '<h2>温馨提示</h2>',
            content: '<h3>会话已过期,请重新登录吧,亲。</h3>'
          });
        }else if(this.resError.status === 403) {
          this.$Modal.error({
            title: '<h2>温馨提示</h2>',
            content: '<h3>抱歉, 您暂时没有操作权限哦。</h3>'
          });
        }else if(this.resError.status === 404) {
          this.$Modal.error({
            title: '<h2>温馨提示</h2>',
            content: '<h3>找不到资源, 请联系管理员!</h3>'
          });
        }else if(this.resError.status === 500){
          this.$Modal.error({
            title: '<h2>温馨提示</h2>',
            content: '<h3>网络异常, 请稍后再试!</h3>'
          });
        }else if(this.resError.status != 200){
          this.$Modal.error({
            title: '<h2>温馨提示</h2>',
            content: '<h3>网络异常, 请稍后刷新一下!</h3>'
          });
        }
      }
    },
  },
};
</script>
<style lang="postcss" scoped>
#error {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  & .ivu-alert {
    border-style: none;
    margin-bottom: 0;
    min-height: 100%;
  }
  & .title {
    margin-bottom: 12px;
  }
  & .desc {
    padding: 0 24px;
  }
  & .ivu-alert-warning {
    background-color: rgba(255, 255, 204, 0.8);
    & .desc {
      border: 1px dashed #c90;
      color: #333;
    }
  }
  & .ivu-alert-error {
    background-color: rgba(253, 236, 232, 0.8);
    & .desc {
      border: 1px dashed #f33;
      color: #f33;
    }
  }
}
</style>
